export interface BackLinkState {
  fromPath: string;
  fromLabel: string;
  restoreComicKey?: string;
}

export interface LocationStateWithBack {
  back?: BackLinkState;
}

export function isLocationStateWithBack(value: unknown): value is LocationStateWithBack {
  if (!value || typeof value !== 'object') return false;
  const maybe = value as {
    back?: { fromPath?: unknown; fromLabel?: unknown; restoreComicKey?: unknown };
  };
  return (
    typeof maybe.back?.fromPath === 'string' &&
    typeof maybe.back.fromLabel === 'string' &&
    (
      maybe.back.restoreComicKey === undefined ||
      typeof maybe.back.restoreComicKey === 'string'
    )
  );
}

export function comicCardRestoreKey(source: string, id: string): string {
  return `${source}:${id}`;
}

export function restoreComicKeyFromLocationState(value: unknown): string | undefined {
  if (!value || typeof value !== 'object') return undefined;
  const maybe = value as {
    back?: { restoreComicKey?: unknown };
    restoreComicKey?: unknown;
  };
  if (typeof maybe.back?.restoreComicKey === 'string') return maybe.back.restoreComicKey;
  if (typeof maybe.restoreComicKey === 'string') return maybe.restoreComicKey;
  return undefined;
}

export function hasBrowserBackEntry(): boolean {
  if (typeof window === 'undefined') return false;
  const state = window.history.state as { idx?: unknown } | null;
  return typeof state?.idx === 'number' && state.idx > 0;
}

export function safeInternalPath(path: string): string {
  return path.startsWith('/') && !path.startsWith('//') ? path : '/';
}
